import { useState } from "react";
import { programs } from "../data/programs.js";

export default function Programs() {
  const [flipped, setFlipped] = useState({});

  const handleFlip = (i) => {
    setFlipped((prev) => ({ ...prev, [i]: !prev[i] }));
  };

  return (
    <section >
        <div className="flex items-center justify-between pt-5 pb-1">
          <h2 className="text-[#0e1b17] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 md:px-0 pb-3 pt-5">
            Our Programs
          </h2>
        </div>

      {/* Mobile: horizontal scroll | Desktop: grid (no scroll) */}
      <div
        className="
          md:hidden
          flex overflow-x-auto gap-3 p-4
          [-ms-scrollbar-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden
        "
        aria-label="Programs slider"
      >
        {programs.map((p, i) => {
          const { title, subtitle, image, description } = p || {};
          const bg =
            typeof image === "string" && image.startsWith("url(")
              ? image
              : `url(${image})`;

          return (
            <article
              key={i}
              className="group min-w-[15rem] w-60 [perspective:1000px] focus:outline-none"
              tabIndex={0}
              aria-label={`${title} card`}
            >
              {/* 3D flip wrapper */}
              <div
                className={`relative h-[280px] w-full transition-transform duration-500 [transform-style:preserve-3d] motion-reduce:transition-none motion-reduce:[transform:none] ${flipped[i] ? '[transform:rotateY(180deg)]' : ''}`}
                onClick={() => handleFlip(i)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') handleFlip(i);
                }}
                tabIndex={0}
                role="button"
                aria-pressed={!!flipped[i]}
              >
                {/* FRONT */}
                <div className="absolute inset-0 [backface-visibility:hidden] bg-white rounded-xl shadow-sm overflow-hidden">
                  <div
                    className="w-full aspect-video bg-center bg-no-repeat bg-cover"
                    style={{ backgroundImage: bg }}
                    role="img"
                    aria-label={title}
                  />
                  <div className="p-3">
                    <p className="text-[#0e1b17] text-base font-medium leading-normal">
                      {title}
                    </p>
                    {subtitle && (
                      <p className="text-[#4e977f] text-sm leading-normal">{subtitle}</p>
                    )}
                  </div>
                  <div className="text-xs text-gray-700 text-center pt-3">Tap to flip</div>
                </div>

                {/* BACK */}
                <div className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] rounded-xl shadow-sm overflow-hidden bg-white">
                  <div className="h-full flex flex-col p-4">
                    <h3 className="text-[#0e1b17] text-base font-semibold leading-tight">
                      {title}
                    </h3>
                    {subtitle && (
                      <p className="text-[#4e977f] text-sm leading-normal">{subtitle}</p>
                    )}
                    <div className="mt-3 text-sm text-[#2a3a36] leading-relaxed line-clamp-6 overflow-auto">
                      {description}
                    </div>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>

      {/* Desktop: 4 cards across (wrap if >4); no scrolling */}
      <div className="hidden md:grid lg:grid-cols-4 grid-cols-2 gap-4 p-4">
        {programs.map((p, i) => {
          const { title, subtitle, image, description } = p || {};
          const bg =
            typeof image === "string" && image.startsWith("url(")
              ? image
              : `url(${image})`;

          return (
            <article
              key={i}
              className="group w-full [perspective:1000px] focus:outline-none"
              tabIndex={0}
              aria-label={`${title} card`}
            >
              <div
                className="relative h-[300px] w-full transition-transform duration-500 [transform-style:preserve-3d]
                           group-hover:[transform:rotateY(180deg)] group-focus-within:[transform:rotateY(180deg)]
                           motion-reduce:transition-none motion-reduce:[transform:none]"
              >
                {/* FRONT */}
                <div className="absolute inset-0 [backface-visibility:hidden] bg-white rounded-xl shadow-sm overflow-hidden">
                  <div
                    className="w-full aspect-video bg-center bg-no-repeat bg-cover"
                    style={{ backgroundImage: bg }}
                    role="img"
                    aria-label={title}
                  />
                  <div className="p-3">
                    <p className="text-[#0e1b17] text-base font-medium leading-normal">
                      {title}
                    </p>
                    {subtitle && (
                      <p className="text-[#4e977f] text-sm leading-normal">{subtitle}</p>
                    )}
                  </div>
                </div>

                {/* BACK */}
                <div className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] rounded-xl shadow-sm overflow-hidden bg-white">
                  <div className="h-full flex flex-col p-4">
                    <h3 className="text-[#0e1b17] text-base font-semibold leading-tight">
                      {title}
                    </h3>
                    {subtitle && (
                      <p className="text-[#4e977f] text-sm leading-normal">{subtitle}</p>
                    )}
                    <div className="mt-3 text-sm text-[#2a3a36] leading-relaxed overflow-auto">
                      {description}
                    </div>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
